/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_PRODUCTS, GET_PRODUCTS } from 'src/actions/recipeActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const recipeReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PRODUCTS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_PRODUCTS: {
      const { recipes, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = recipes;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default recipeReducer;
